import { createRoute } from '@tanstack/react-router';
import { ForecastPage } from '@/features/finance/Forecast';
import { Route as shellRoute } from '../_shell';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/finance/forecast',
  component: ForecastPage,
});
